var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stars"},_vm._l((_vm.count),function(index){return _c('eg-icon',{key:index,attrs:{"icon":"star-filled","size":"extra-small"}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }